import { styled } from '@mui/material';
export const ContainerCardStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-evenly',
}));
export const DetailTitleStyled = styled('div')(() => ({
  fontWeight: '600',
  fontSize: '15px',
  lineHeight: '38px',
  marginTop: '15px',
}));
export const StyledText = styled('text')(({ theme }) => ({
  fill: theme.palette.text.primary,
  textAnchor: 'middle',
  dominantBaseline: 'central',
  fontSize: 20,
}));
export const IconBackgroundLayerStyled = styled('div')(() => ({
  width: 40,
  height: 40,
  border: '2px dashed #D8DBDE',
  borderStyle: 'dashed',
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
export const IconBackgroundStyled = styled('div')(({ theme }) => ({
  background: theme.palette.info.main,
  width: 30,
  height: 30,
  borderRadius: '50%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
export const TitleBackgroundStyled = styled('div')(({ theme }) => ({
  borderRadius: '0px 0px 5px 5px',
  background: theme.palette.info.lighter,
  marginLeft: '10px',
  marginRight: '20px',
}));
export const RatingFieldStyled = styled('div')(() => ({
  fontWeight: 600,
  fontSize: 14,
  borderBottom: 'none',
  verticalAlign: 'top',
}));
